import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@glu/theming';

const styles = ({ oaoButtons: buttons, palette, screenSizes }) => ({
  link: {
    ...buttons.primary,
    '&:hover': {
      background: buttons.primary.hoverBackground,
      borderColor: buttons.primary.hoverBorderColor,
      color: buttons.primary.hoverColor,
      textDecoration: 'none',
    },
    display: 'block',
    margin: [0, 'auto'],
    position: 'relative',
    textAlign: 'center',
    textDecoration: 'none',
    transition: 'background 200ms ease',
    width: 275,
  },
  root: {
    '& p': {
      marginBottom: 54,
      marginTop: 24,
    },
    display: 'flex',
    justifyContent: 'space-between',
    margin: [0, 'auto'],
    maxWidth: 1150,
  },
  separator: {
    borderLeft: `1px solid ${palette.form.border}`,
    width: 1,
  },
  side: {
    flex: 1,
    maxWidth: 440,
    textAlign: 'center',
  },
  [`@media(max-width: ${screenSizes.mobileMax}px)`]: {
    root: {
      '& p': {
        fontSize: 18,
      },
      display: 'block',
    },
    separator: {
      display: 'none',
    },
    side: {
      '&:first-child': {
        marginBottom: 54,
        marginTop: 24,
      },
      margin: [0, 'auto'],
      maxWidth: 335,
    },
  },
});

const SSOHome = ({
  classes,
  group1Description,
  group1LinkDestination,
  group1LinkLabel,
  group1Title,
  group2Description,
  group2LinkDestination,
  group2LinkLabel,
  group2Title,
}) => (
  <div className={classes.root}>
    <div className={classes.side}>
      <h1>{group1Title}</h1>
      <p>{group1Description}</p>
      <a className={classes.link} href={group1LinkDestination}>
        {group1LinkLabel}
      </a>
    </div>
    <div className={classes.separator} />
    <div className={classes.side}>
      <h1>{group2Title}</h1>
      <p>{group2Description}</p>
      <a className={classes.link} href={group2LinkDestination}>
        {group2LinkLabel}
      </a>
    </div>
  </div>
);

SSOHome.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  group1Description: PropTypes.string.isRequired,
  group1LinkDestination: PropTypes.string.isRequired,
  group1LinkLabel: PropTypes.string.isRequired,
  group1Title: PropTypes.string.isRequired,
  group2Description: PropTypes.string.isRequired,
  group2LinkDestination: PropTypes.string.isRequired,
  group2LinkLabel: PropTypes.string.isRequired,
  group2Title: PropTypes.string.isRequired,
};

const SSOHomeStyled = withStyles(styles)(SSOHome);

const mapStateToProps = ({ groups, resources }) => {
  const [group1Key, group2Key] = Object.keys(groups);
  const group2IsHome = group2Key.match(/app/i);

  const [group1LinkKey, group2LinkKey] = group2IsHome
    ? ['viewProductsBtnLabel', 'viewApplicationsBtnLabel']
    : ['viewApplicationsBtnLabel', 'viewProductsBtnLabel'];
  const [group1LinkDestination, group2LinkDestination] = group2IsHome
    ? ['/branch', '/oao/home']
    : ['/oao/home', '/branch'];

  return {
    group1Description: groups[group1Key].description,
    group1LinkDestination,
    group1LinkLabel: resources[group1LinkKey],
    group1Title: groups[group1Key].title,
    group2Description: groups[group2Key].description,
    group2LinkDestination,
    group2LinkLabel: resources[group2LinkKey],
    group2Title: groups[group2Key].title,
  };
};

export default connect(mapStateToProps)(SSOHomeStyled);
